var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "100%",
    width: "100%",
    viewBox: "0 0 240 84",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3.5s",
    begin: "0s",
    fill: "freeze",
    values: "0; 1; 1",
    keyTimes: "0; 0.085714; 1",
    keySplines: "0.24 0.75 0.35 0; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,84)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "240 84; 0 0; 0 0",
    keyTimes: "0; 0.085714; 1",
    keySplines: "0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "0 0; 1 1; 1 1",
    keyTimes: "0; 0.085714; 1",
    keySplines: "0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#334423",
    d: "M138.58,77.801C138.58,77.801,121.451,35.213,121.451,35.213C121.451,35.213,139.514,35.213,139.514,35.213C139.514,35.213,152.517,69.782,152.517,69.782C152.517,69.782,143.407,69.782,143.407,69.782C143.407,69.782,157.266,35.213,157.266,35.213C157.266,35.213,173.927,35.213,173.927,35.213C173.927,35.213,156.799,77.801,156.799,77.801C156.799,77.801,138.58,77.801,138.58,77.801C138.58,77.801,138.58,77.801,138.58,77.801Z"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3.5s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 1",
    keyTimes: "0; 0.064286; 0.171429; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,84)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "240 84; 240 84; 0 0; 0 0",
    keyTimes: "0; 0.064286; 0.171429; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "0 0; 0 0; 1 1; 1 1",
    keyTimes: "0; 0.064286; 0.171429; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#334423",
    d: "M101.847,77.801C101.847,77.801,101.847,20.031,101.847,20.031C101.847,20.031,119.443,20.031,119.443,20.031C119.443,20.031,119.443,77.801,119.443,77.801C119.443,77.801,101.847,77.801,101.847,77.801C101.847,77.801,101.847,77.801,101.847,77.801Z"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3.5s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 1",
    keyTimes: "0; 0.128571; 0.257143; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,84)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "240 84; 240 84; 0 0; 0 0",
    keyTimes: "0; 0.128571; 0.257143; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "0 0; 0 0; 1 1; 1 1",
    keyTimes: "0; 0.128571; 0.257143; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#334423",
    d: "M75.352,64.877C76.65,64.877,77.818,64.565,78.856,63.943C79.894,63.32,80.724,62.385,81.347,61.14C81.97,59.842,82.282,58.285,82.282,56.468C82.282,54.6,81.97,53.068,81.347,51.875C80.724,50.629,79.894,49.695,78.856,49.072C77.818,48.449,76.65,48.137,75.352,48.137C74.055,48.137,72.887,48.449,71.849,49.072C70.811,49.695,69.98,50.629,69.357,51.875C68.734,53.068,68.423,54.6,68.423,56.468C68.423,58.285,68.734,59.842,69.357,61.14C69.98,62.385,70.811,63.32,71.849,63.943C72.887,64.565,74.055,64.877,75.352,64.877C75.352,64.877,75.352,64.877,75.352,64.877ZM75.352,78.58C70.525,78.58,66.243,77.646,62.506,75.777C58.821,73.856,55.914,71.235,53.786,67.913C51.658,64.591,50.594,60.776,50.594,56.468C50.594,52.16,51.658,48.345,53.786,45.023C55.914,41.701,58.821,39.106,62.506,37.237C66.243,35.369,70.525,34.434,75.352,34.434C80.179,34.434,84.462,35.369,88.199,37.237C91.936,39.106,94.843,41.701,96.919,45.023C99.047,48.345,100.111,52.16,100.111,56.468C100.111,60.776,99.047,64.591,96.919,67.913C94.843,71.235,91.936,73.856,88.199,75.777C84.462,77.646,80.179,78.58,75.352,78.58C75.352,78.58,75.352,78.58,75.352,78.58Z"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3.5s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 1",
    keyTimes: "0; 0.192857; 0.342857; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,84)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "240 84; 240 84; 0 0; 0 0",
    keyTimes: "0; 0.192857; 0.342857; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "0 0; 0 0; 1 1; 1 1",
    keyTimes: "0; 0.192857; 0.342857; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#334423",
    d: "M23.885,79.047C19.318,79.047,14.906,78.528,10.65,77.49C6.393,76.452,2.89,75.102,0.139,73.441C0.139,73.441,6.056,60.05,6.056,60.05C8.651,61.555,11.532,62.775,14.698,63.709C17.916,64.591,21.031,65.033,24.041,65.033C25.806,65.033,27.181,64.929,28.168,64.721C29.206,64.462,29.958,64.124,30.425,63.709C30.893,63.242,31.126,62.697,31.126,62.074C31.126,61.088,30.581,60.309,29.491,59.738C28.401,59.167,26.948,58.7,25.131,58.337C23.366,57.922,21.42,57.506,19.292,57.091C17.164,56.624,15.01,56.027,12.83,55.3C10.701,54.574,8.729,53.613,6.912,52.42C5.148,51.226,3.72,49.669,2.63,47.748C1.54,45.776,0.995,43.336,0.995,40.43C0.995,37.056,1.929,33.993,3.798,31.242C5.718,28.439,8.547,26.208,12.285,24.547C16.074,22.886,20.771,22.055,26.377,22.055C30.062,22.055,33.695,22.444,37.277,23.223C40.858,24.002,44.076,25.195,46.931,26.804C46.931,26.804,41.403,40.118,41.403,40.118C38.704,38.769,36.083,37.756,33.54,37.082C31.048,36.407,28.609,36.07,26.221,36.07C24.456,36.07,23.055,36.225,22.017,36.537C20.979,36.848,20.226,37.263,19.759,37.782C19.344,38.301,19.136,38.872,19.136,39.495C19.136,40.43,19.681,41.182,20.771,41.753C21.861,42.272,23.288,42.713,25.053,43.077C26.87,43.44,28.842,43.829,30.97,44.245C33.15,44.66,35.304,45.231,37.433,45.957C39.561,46.684,41.507,47.644,43.272,48.838C45.089,50.032,46.542,51.589,47.632,53.51C48.722,55.43,49.267,57.818,49.267,60.673C49.267,63.994,48.307,67.057,46.386,69.86C44.518,72.611,41.715,74.843,37.978,76.556C34.24,78.217,29.543,79.047,23.885,79.047C23.885,79.047,23.885,79.047,23.885,79.047Z"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3.5s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 1",
    keyTimes: "0; 0.257143; 0.428571; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,84)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "240 84; 240 84; 48.42 161.608; 48.42 161.608",
    keyTimes: "0; 0.257143; 0.428571; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "0 0; 0 0; 1 1; 1 1",
    keyTimes: "0; 0.257143; 0.428571; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 14.119,
    width: 14.119,
    y: 22.356,
    x: 219.288,
    fill: "#334423"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3.5s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 1",
    keyTimes: "0; 0.321429; 0.514286; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,84)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "240 84; 240 84; 0 0; 0 0",
    keyTimes: "0; 0.321429; 0.514286; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "0 0; 0 0; 1 1; 1 1",
    keyTimes: "0; 0.321429; 0.514286; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 36.831,
    rx: 36.831,
    cy: 47.169,
    cx: 192.046,
    fill: "#334423"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3.5s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 1",
    keyTimes: "0; 0.385714; 0.6; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,84)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "240 84; 240 84; 0 0; 0 0",
    keyTimes: "0; 0.385714; 0.6; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "0 0; 0 0; 1 1; 1 1",
    keyTimes: "0; 0.385714; 0.6; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669137",
    d: "M194.329,47.315C194.329,47.315,204.312,37.331,204.312,37.331C204.312,37.331,214.296,47.315,214.296,47.315C214.296,47.315,204.312,57.298,204.312,57.298C204.312,57.298,194.329,47.315,194.329,47.315C194.329,47.315,194.329,47.315,194.329,47.315Z"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3.5s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 1",
    keyTimes: "0; 0.45; 0.685714; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,84)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "240 84; 240 84; 0 0; 0 0",
    keyTimes: "0; 0.45; 0.685714; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "0 0; 0 0; 1 1; 1 1",
    keyTimes: "0; 0.45; 0.685714; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669137",
    d: "M206.808,34.835C206.808,34.835,216.792,24.852,216.792,24.852C216.792,24.852,226.775,34.835,226.775,34.835C226.775,34.835,216.792,44.819,216.792,44.819C216.792,44.819,206.808,34.835,206.808,34.835C206.808,34.835,206.808,34.835,206.808,34.835Z"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3.5s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 1",
    keyTimes: "0; 0.514286; 0.771429; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,84)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "240 84; 240 84; 0 0; 0 0",
    keyTimes: "0; 0.514286; 0.771429; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "0 0; 0 0; 1 1; 1 1",
    keyTimes: "0; 0.514286; 0.771429; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669137",
    d: "M181.91,59.947C181.91,59.947,191.894,49.964,191.894,49.964C191.894,49.964,201.878,59.947,201.878,59.947C201.878,59.947,191.894,69.931,191.894,69.931C191.894,69.931,181.91,59.947,181.91,59.947C181.91,59.947,181.91,59.947,181.91,59.947Z"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "3.5s",
    begin: "0s",
    fill: "freeze",
    values: "0; 0; 1; 1",
    keyTimes: "0; 0.578571; 0.857143; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,84)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "240 84; 240 84; 0 0; 0 0",
    keyTimes: "0; 0.578571; 0.857143; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "3.5s",
    begin: "0s",
    calcMode: "spline",
    values: "0 0; 0 0; 1 1; 1 1",
    keyTimes: "0; 0.578571; 0.857143; 1",
    keySplines: "0 0 1 1; 0.24 0.75 0.35 0; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669137",
    d: "M169.431,47.468C169.431,47.468,179.415,37.484,179.415,37.484C179.415,37.484,189.398,47.468,189.398,47.468C189.398,47.468,179.415,57.452,179.415,57.452C179.415,57.452,169.431,47.468,169.431,47.468C169.431,47.468,169.431,47.468,169.431,47.468Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerLogoDark);
export default __webpack_public_path__ + "static/media/spinner_logo_dark.0c1f0c5a2b35a4e530787538d7dacd14.svg";
export { ForwardRef as ReactComponent };